module.exports = fox._r("images/mcb-share-triangle.png", __webpack_public_path__ + "_/_/_/common/frame/images/mcb-share-triangle.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/mcb-share-triangle.png
// module id = 390
// module chunks = 2